<template>
    <div class="table-wrapper" style="padding-top: 20px;">
        <Form ref="formInline" :model="formInline" inline
            :label-width="100" label-position="right">
            <div class="search-right-wrapper">
                <Button type="primary" style="float:left;" @click="handleExport" icon="ios-exit-outline">导出</Button>
                <FormItem label="时间选择:">
                    <DatePicker type="daterange" split-panels placeholder="请选择" @on-change="timeChange" ></DatePicker>
                </FormItem>
                <FormItem label="数据对接标准:"  style="width:286px;text-align:left;">
                    <Select v-model="exportData.dockStandard" clearable>
                        <Option v-for="item in targets" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <Button style="float: right;" type="primary" @click="getTableData1">搜索</Button>
            </div>
        </Form>
        <Table :loading="loading" border :columns="tableColumns" :data="tableData" highlight-row>
             <template slot-scope="{ row, index }" slot="dataDockStandard">
                 <a :href="hrefPath" target="_blank">{{row.dataDockStandard}}</a>
             </template>
        </Table>
        <div class="t-page">
            <Page :total="totalCount" :page-size="exportData.pageSize" :current="exportData.page"
                @on-change="changePage" @on-page-size-change="pageSizeChange"
                show-elevator show-sizer show-total transfer>
            </Page>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    import {mapState} from 'vuex';
    import tableMixin from '@/components/tableMixin';
    export default {
        mixins: [tableMixin],
        data(){
            return {
                hrefPath: process.env.BASE_URL+'file/陕西省城乡建设厅建筑工人实名制数据接口标准V1.2(试行版).docx',
                targets: [],
                formInline:{
                    startDate:'',
                    endDate:''
                },
                formOutLine1: {
                    startDate:'',
                    endDate:''
                },
                tableColumns:[
                    {
                        title: '序号',
                        type: 'index',
                        width: 70,
                        align: 'center'
                    },
                    {
                        title: '数据推送目的地',
                        key: 'targetName',
                        minWidth:100,
                    },
                     {
                        title: '数据推送时间',
                        key: 'lastPushTime',
                        minWidth:180,
                    },
                    {
                        title: '数据总条数',
                        key: 'dataTotalCount',
                        minWidth:150,
                        align: 'center'
                    },
                    {
                        title: '数据类型',
                        key: 'dataType',
                        minWidth:150
                    },
                    {
                        title: '数据对接标准',
                        slot: 'dataDockStandard',
                        minWidth:300
                    }
                    // {
                    //     title: '操作',
                    //     slot: 'action',
                    //     align: 'center',
                    //     width: 100
                    // }
                ],
                tableData:[],
                exportData:{
                    pageSize: 10,
                    page: 1,
                    targetName: '',
                    dockStandard: ''
                }
            };
        },
        computed:{
            ...mapState(['areaCode']),
        },
        created(){

        },
        mounted(){
            this.exportData.targetName = this.$route.query.targetName
			if(this.exportData.targetName) {
				this.getTargets()
				this.getTableData1()
			}
        },
        watch: {
            // '$route': function (to, from) {
            //     if(to.name==='checking-inList'){
            //         this.getTableData();
            //     }
            // },
            // areaCode: function () {
            //     this.getTableData();
            // },
        },
        methods: {
            getTargets() {
                this.axios({
                    method: 'get',
                    url:'/dataPush/dockDataStandards'
                }).then( (response)=> {
                    response.data.data.map(item => {
                        this.targets.push({
                            value: item,
                            label: item
                        })
                    })
                });
            },
            pageSizeChange(val) {
                this.exportData.pageSize = val
                this.getTableData1()
            },
            changePage(val){
                this.exportData.page = val
                this.getTableData1()
            },
            timeChange(val) {
                this.formInline.startDate = val[0]
                this.formInline.endDate = val[1]
            },
            //导出
            handleExport(){
                let param={
                    startDate: this.formInline.startDate,
                    endDate: this.formInline.endDate,
                    pageSize:this.exportData.pageSize,
                    startNum:this.exportData.page,
                    targetName: this.exportData.targetName,
                    dockStandard: this.exportData.dockStandard
                };
                this.axios({
                    method: 'post',
                    url:'/dataPush/detail/export',
                    responseType:'arraybuffer',
                    data: param
                }).then( (response)=> {
                    this.common.download(response, '数据推送.xls','application/vnd.ms-excel');
                });
            },
            /*处理操作*/
            handleDeal(name,id){
                this.$router.push({
                    name: name,
                    query: {
                        id:id
                    }
                });
            },
            /*获取表格数据*/
            getTableData1(){
                let param={
                    startDate: this.formInline.startDate,
                    endDate: this.formInline.endDate,
                    pageSize:this.exportData.pageSize,
                    startNum:this.exportData.page,
                    targetName: this.exportData.targetName,
                    dockStandard: this.exportData.dockStandard
                };
                // this.exportData=param;
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/dataPush/detail/list',
                    data:param
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        this.totalCount = response.data.data.total
                        this.tableData=response.data.data.list
                    }
                }).catch( ()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>
<style scoped >
    .dataTab .ivu-tabs-bar {
        margin-bottom: 0;
        border-bottom: none;
    }
</style>
